import React from 'react';
import { motion } from 'framer-motion';
import { Gift, CalendarClock } from 'lucide-react';
export function SpecialOffer() {
  return <section className="py-12 bg-gold-500 relative overflow-hidden" data-id="element-239">
      {/* Pattern overlay */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#000 1px, transparent 1px)',
      backgroundSize: '20px 20px'
    }} data-id="element-240"></div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-241">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex flex-col md:flex-row items-center justify-between bg-white/10 backdrop-blur-sm border border-white/20 rounded-3xl p-8 md:p-12 shadow-2xl" data-id="element-242">
          <div className="flex-1 mb-8 md:mb-0 md:mr-12 text-center md:text-left" data-id="element-243">
            <div className="inline-flex items-center gap-2 bg-navy-900 text-white px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wider mb-6" data-id="element-244">
              <Gift size={16} className="text-gold-400" data-id="element-245" />
              ¡Oferta Especial!
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-navy-900 mb-4 leading-tight" data-id="element-246">
              Remodele su piscina y reciba{' '}
              <span className="text-white drop-shadow-md" data-id="element-247">
                2-3 meses de mantenimiento GRATIS
              </span>
            </h2>
            <p className="text-navy-800 text-lg font-medium flex items-center justify-center md:justify-start gap-2" data-id="element-248">
              <CalendarClock size={20} data-id="element-249" />
              Cupos limitados — Reserve su inspección hoy mismo.
            </p>
          </div>

          <div className="flex-shrink-0" data-id="element-250">
            <a href="#contacto" className="inline-block bg-navy-900 hover:bg-navy-800 text-white font-bold text-xl py-5 px-10 rounded-full transition-transform hover:scale-105 shadow-xl whitespace-nowrap" data-id="element-251">
              Aproveche Esta Oferta
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}